import { dashboardInitialState } from '@modules/dashboard/store/dashboardInitialState';
import { dashboardReducer } from '@modules/dashboard/store/dashboardReducer';
import { create } from 'zustand';
import { devtools, redux } from 'zustand/middleware';

export const useDashboardStore = create(
  devtools(redux(dashboardReducer, dashboardInitialState), {
    name: 'DashboardStore',
  }),
);
